import { render, staticRenderFns } from "./EventMailPage.vue?vue&type=template&id=dd9a72f2"
import script from "./EventMailPage.vue?vue&type=script&lang=js"
export * from "./EventMailPage.vue?vue&type=script&lang=js"
import style0 from "./EventMailPage.vue?vue&type=style&index=0&id=dd9a72f2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports